import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { APP_NAME, HAS_INSTANT_DISCOUNT, APPLICATION_SPECIFIC_STATIC_ROOT } from '../../constants';

import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';
import { getI18nByApp } from '../../services/i18n/selector';

const LogoWrapper = styled.div`
    display: flex;
    align-items: center;
    ${props => props.center && `justify-content: center;`}

    div {
        border-right: 1px solid ${props => props.theme.grey};
        padding-right: 10px;
    }

    img {
        height: auto;
    }

    span {
        margin-left: 10px;
        font-size: 18px;
        font-weight: ${props => props.theme.boldWeight};
        text-decoration: none;
        color: ${props => props.theme.black};
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        img {
            max-height: 25px;
            width: auto;
        }

        span {
            font-size: 11px;
        }
    }

    @media screen and (max-width: ${props => props.theme.xTiny}) {
        ${props =>
            !props.instantDiscount &&
            `div {
                border-right: none;
            }

            span {
                display: none;
            }`}
`;

const mapStateToProps = state => ({
    i18n: state.i18n
});
export const Logo = connect(mapStateToProps)(({ className, center, i18n, CASHBACK_DISCOUNT }) => (
    <LogoWrapper instantDiscount={HAS_INSTANT_DISCOUNT} center={center}>
        <div>
            <img
                height={45}
                width={151}
                src={`${APPLICATION_SPECIFIC_STATIC_ROOT}/logo.png`}
                alt={APP_NAME}
                className={className}
            />
        </div>
        <span>
            {convertHtmlToReactDomWithParams(
                HAS_INSTANT_DISCOUNT
                    ? getI18nByApp(i18n, 'feature.header.LOGO_TEXT_INSTANT_DISCOUNT')
                    : getI18nByApp(i18n, 'feature.header.LOGO_TEXT_CASHBACK_DISCOUNT')
            )}
        </span>
    </LogoWrapper>
));

export default connect(mapStateToProps)(Logo);



// WEBPACK FOOTER //
// ./src/components/icons/Logo.js